export default function AssessmentsDirective() {
  return {
    template: require('./assessments.html'),
    scope: {
      activeAssessments: '=',
      hasActiveAssessments: '=',
      completedAssessments: '=',
      hasCompletedAssessments: '=',
      isNavantaUser: '=',
    },
    controller: 'ECATAssessmentsController',
    controllerAs: 'assessmentsVM',
    bindToController: true,
    replace: true,
  };
}
